import {makeAutoObservable} from "mobx";

export class NewsStorage {
    LAST_SHOWN_DATES = 'backoffice-news-last-shown-dates';

    constructor(storage) {
        this._storage = storage;
        makeAutoObservable(this);
    }

    lastShownDatesByNewsId() {
        const storedValue = this._storage.get(this.LAST_SHOWN_DATES);
        if (!storedValue) {
            return {};
        }
        try {
            return JSON.parse(storedValue) || {};
        } catch (error) {
            return {};
        }
    }

    markNewsAsShown(newsIds, onDate) {
        const lastShownDatesByNewsId = this.lastShownDatesByNewsId();
        const onDateAsYearMonthDayString = this._asYearMonthDayString(onDate);
        newsIds.forEach((newsId) => {
            lastShownDatesByNewsId[newsId] = onDateAsYearMonthDayString;
        });
        this._storage.add(this.LAST_SHOWN_DATES, JSON.stringify(lastShownDatesByNewsId));
    }

    _asYearMonthDayString(aDate) {
        const year = aDate.getFullYear();
        const month = String(aDate.getMonth() + 1).padStart(2, '0');
        const day = String(aDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
}
